import { render } from "./Feedback.vue?vue&type=template&id=283a11f5&scoped=true"
import script from "./Feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./Feedback.vue?vue&type=script&setup=true&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=283a11f5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283a11f5"],['__file',"src/pages/common/Feedback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "283a11f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('283a11f5', __exports__)) {
    console.log('reload')
    api.reload('283a11f5', __exports__)
  }
  
  module.hot.accept("./Feedback.vue?vue&type=template&id=283a11f5&scoped=true", () => {
    console.log('re-render')
    api.rerender('283a11f5', render)
  })

}


export default __exports__